export class ProfileModel {
  userName?: string = '';
  password?: string = '';
  remember?: boolean = false;
}
